export default "__VITE_ASSET__wyCQ75tB__"